"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLitigationApplication = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const litigationApplicationFlowConfig = new FlowConfig_1.default({
    list: [
        'ufo_cs_ss_10',
        'ufo_cs_ss_20',
        'ufo_cs_ss_30',
        'ufo_cs_ss_40',
        'ufo_cs_ss_50',
        'ufo_cs_ss_60', // 结束
    ]
});
const toLitigationApplication = function (litigationApplicationId, flowId, flowKey) {
    if (flowKey === 'start') {
        flowKey = litigationApplicationFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = litigationApplicationFlowConfig.getEnd();
    }
    router_1.default.push(`/litigation/application/info/${litigationApplicationId}/${(0, utils_1.simpleEncrypt)(flowId)}/${(0, utils_1.simpleEncrypt)(flowKey)}`);
};
exports.toLitigationApplication = toLitigationApplication;
exports.default = litigationApplicationFlowConfig;
